import { dataService } from '../../data';

import { DataObject, ObjectOptions, RelatedObject } from "../base";
import { CreateObject } from "../item";
import { Category } from './category';

/****************************/
/* SCHEMA DEFINITION        */
/****************************/

import { CategoryType } from '../types';
import { ProductOptType } from '../types';

const _schema = {
    "name": "CATEGORYDEP",
    "fields": [
        { name: "status", type: "string" },
        { name: "category", type: "objid" },
        { name: "productopt", type: "objid", alias: "option" },
    ],
    relate: [
        { direction: ">", target: "CATEGORY", by: "category", name: "category", reason: "category", child: false, class: CategoryType },
        { direction: ">", target: "PRODUCTOPT", by: "productopt", name: "option", reason: "option", child: false, class: ProductOptType  },
    ]
} as const;

const _CategoryDepClass = CreateObject(_schema);
if (!_CategoryDepClass) {
    throw new Error("Failed to create BaseClass for '" + _schema.name + "'");
}

/****************************/
/* CLASS DECLARATION        */
/****************************/

export class CategoryDep extends _CategoryDepClass { 
    constructor(objid: string | null, data: dataService, objoptions: ObjectOptions | null = null){
        super(_schema, objid, data, objoptions || {});
    }

    Copy(store: Array<DataObject> = []): CategoryDep {
        return this._Copy(store) as CategoryDep;
    }

    protected override DoChildLinked(relation: string | null, related: RelatedObject | null): void {
        if (this.CopyOf || !this.Commited){
            return;
        }

        if (relation === 'category' && related instanceof Category){
            if (related === this.category){
                related.AddDepend(this);
            }
        }
    }

    /****************************/
    /* CLASS MEMBERS            */
    /****************************/

    get status(): string | null {
        return this['__base__status']
    }

    set status(value: string){
        if (this.status == 'DE'){
            return;     // cannot modify deleted items
        }

        if (this.status == value){
            return;
        }

        this['__base__status'] = value;
        if (this.category){
            if ((this.status == 'DE') && !this.Commited){
                this.category.DelDepend(this);
            }
            else {
                this.category.DoRefresh(this.table);
            }    
        }
    }

    /****************************/
    /* CATALOG CONSIDERATIONS   */
    /****************************/

    override get IsCatalog(): boolean {
        return super.IsCatalog;
    }

    override set IsCatalog(value: boolean){
        if (value == this.IsCatalog){
            return;
        }

        super.IsCatalog = value;
        if (value == false){
            if (this.status == 'CT'){
                this.status = 'AC';
            }

            for (const _child of this.Children){
                _child.IsCatalog = value;
            }
        }
    }
        
    /****************************/
    /* CUSTOM METHODS           */
    /****************************/

    get IsValid(): boolean {
        return (!!this.status && (this.status != 'DE'));
    }
}

